import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RoomRoutingModule } from './room-routing.module';
import { SharedModule } from '@shared/shared.module';
import { RoomComponent } from './room.component';
import { HeaderComponent } from './header/header.component';
import { ControlsComponent } from './controls/controls.component';
import { VideosComponent } from './videos/videos.component';
import { ChatComponent } from './chat/chat.component';
import { RecordingControlComponent } from './controls/recording-control/recording-control.component';
import { DynamicTilesDirective } from './videos/directives/dynamic-tiles.directive';
import { ScreenShareControlComponent } from './controls/screen-share-control/screen-share-control.component';
import { MenuMobileComponent } from './menu-mobile/menu-mobile.component';
import { ParticipantsComponent } from './participants/participants.component';
import { ZwiftShareControlComponent } from './controls/zwift-share-control/zwift-share-control.component';
import { ZwiftScreenshareComponent } from './videos/zwift-screenshare/zwift-screenshare.component';
import { ParticipantComponent } from './participant/participant.component';

const controlsButtonsComponents = [
  RecordingControlComponent,
  ScreenShareControlComponent,
  ZwiftShareControlComponent
];

@NgModule({
  declarations: [
    RoomComponent,
    HeaderComponent,
    ControlsComponent,
    ...controlsButtonsComponents,
    VideosComponent,
    ChatComponent,
    ParticipantsComponent,
    ParticipantComponent,
    MenuMobileComponent,
    DynamicTilesDirective,
    ZwiftScreenshareComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RoomRoutingModule,
    SharedModule,
  ],
})
export class RoomModule { }
